import React from 'react';
import { connect } from 'react-redux';

import MGMWidget from 'src/universal/components/MGMWidget';
import 'src/universal/components/MGMWidget/__styles__/pdpRedesignWidgetStyles.scss';

import { getPdpCardShortName, getRabBannerLinks } from '../../redux';
import { createDtmAndTrackActionHandler } from 'src/universal/utils/analyticsTracking';

const RABBanner = React.memo(({ shortName = '', rabLink = {} }) => {
  return (
    <MGMWidget
      shortName={shortName}
      onReferNowClick={createDtmAndTrackActionHandler({
        dtmObj: rabLink.dtm || {}
      })}
    />
  );
});

const mapStateToProps = state => ({
  shortName: getPdpCardShortName(state),
  rabLink: getRabBannerLinks(state)
});

export default connect(mapStateToProps)(RABBanner);
